import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const initState = () => ({
  error: null,
  isLoading: false,
  eventHeight: null,
  firstHeight: null,
  info: null,
  latestBlock: null,
  latestTransactions: [],
  latestValidatorSets: [],
  maintenance: true,
  stakingParams: null,
  validators: [],
  validatorsOffset: 0,
  validatorsPagination: null,
});

export default {
  namespaced: true,
  state: initState(),
  getters,
  mutations,
  actions,
};
